import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV = [
    { label: "Weddings", href: "#weddings", testId: "nav-weddings-link" },
    { label: "Repertoire", href: "#repertoire", testId: "nav-repertoire-link" },
    { label: "World Stages", href: "#stages", testId: "nav-stages-link" },
    { label: "The Maestro", href: "#maestro", testId: "nav-maestro-link" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    return (
        <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
                <a href="#top" data-testid="brand-home-link" className="flex items-center gap-3">
                    <img src="/assets/ag-monogram-gold.png" alt="Allen G. Orchestra logo" data-testid="brand-logo" className="h-8 md:h-10 w-auto" />
                    <span className="hidden sm:flex items-baseline gap-2">
                        <span className="font-serif text-xl md:text-2xl tracking-wide text-[#fafafa]">Allen G.</span>
                        <span className="text-[10px] md:text-xs uppercase tracking-[0.35em] text-[#d4af37]">Orchestra</span>
                    </span>
                </a>
                <nav className="hidden md:flex items-center gap-8">
                    {NAV.map((item) => (
                        <a key={item.href} href={item.href} data-testid={item.testId}
                            className="text-xs uppercase tracking-[0.2em] text-[#a1a1aa] hover:text-[#d4af37] transition-colors duration-300">
                            {item.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <a href="#enquire" data-testid="header-enquire-btn"
                        className="hidden md:inline-flex items-center px-5 py-2.5 text-xs uppercase tracking-[0.2em] bg-[#d4af37] text-[#08080a] hover:bg-[#c6a87c] transition-colors duration-300">
                        Contact Us
                    </a>
                    <a href="tel:+13108770250" data-testid="header-call-btn" aria-label="Call Allen G. Orchestra"
                        className="inline-flex items-center justify-center w-10 h-10 border border-white/15 text-[#d4af37] hover:border-[#d4af37] transition-colors duration-300">
                        <Phone size={16} />
                    </a>
                    <button onClick={() => setOpen(!open)} data-testid="mobile-menu-btn" aria-label="Toggle menu"
                        className="md:hidden inline-flex items-center justify-center w-10 h-10 border border-white/15 text-[#fafafa]">
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </div>
            {open && (
                <nav data-testid="mobile-nav" className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
                    {NAV.map((item) => (
                        <a key={item.href} href={item.href} onClick={() => setOpen(false)} data-testid={`mobile-${item.testId}`}
                            className="text-sm uppercase tracking-[0.2em] text-[#fafafa]">
                            {item.label}
                        </a>
                    ))}
                    <a href="#enquire" onClick={() => setOpen(false)} data-testid="mobile-enquire-btn"
                        className="text-sm uppercase tracking-[0.2em] text-[#d4af37]">
                        Contact Us
                    </a>
                </nav>
            )}
        </header>
    );
};
